import React, { memo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import { Class, Subject, QuestionBankFormData } from './types';
import { elegantMenuProps } from '../../utils/menuStyles';

interface CreateBankDialogProps {
  open: boolean;
  classes: Class[];
  modalSubjects: Subject[];
  formData: QuestionBankFormData;
  onClose: () => void;
  onFormChange: (data: QuestionBankFormData) => void;
  onClassChange: (classId: string) => void;
  onSubmit: () => void;
}



const CreateBankDialog = memo<CreateBankDialogProps>(({
  open,
  classes,
  modalSubjects,
  formData,
  onClose,
  onFormChange,
  onClassChange,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Question Bank</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Class *</InputLabel>
            <Select MenuProps={elegantMenuProps}
              value={formData.classId}
              label="Class *"
              onChange={(e) => {
                const classId = e.target.value;
                onFormChange({ ...formData, classId, subjectId: '' });
                onClassChange(classId);
              }}
            >
              <MenuItem value="">Select Class</MenuItem>
              {classes.map((cls) => (
                <MenuItem key={cls._id} value={cls._id}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Subject *</InputLabel>
            <Select MenuProps={elegantMenuProps}
              value={formData.subjectId}
              label="Subject *"
              onChange={(e) => onFormChange({ ...formData, subjectId: e.target.value })}
              disabled={!formData.classId}
            >
              <MenuItem value="">Select Subject</MenuItem>
              {modalSubjects.map((subject) => (
                <MenuItem key={subject._id} value={subject._id}>
                  {subject.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
});

CreateBankDialog.displayName = 'CreateBankDialog';

export default CreateBankDialog;
